import { OnboardingListPage } from './OnboardingListPage';

export default OnboardingListPage;
